const artistsWishlistDE = {
    "view": {
        "table": {
            "title": "Ihre Künstler-Wunschliste",
            "column": {
                "artist_name": "Künstlername",
                "spotify_id": "Spotify-ID",
                "followers": "Follower",
                "popularity": "Beliebtheit (%)",
                "action": "Aktion"
            },
            "dropdown": {
                "action": "Aktion",
                "addAsArtist": "Als Künstler hinzufügen",
                "delete": "Löschen"
            },
            "button": {
                "export_csv": "CSV exportieren"
            },
            "placeholder": {
                "search": "Suche..."
            },
            "message": {
                "error": "Etwas ist schief gelaufen! Bitte Seite aktualisieren und erneut versuchen!"
            }
        },
        "modal": {
            "removeArtist": {
                "header": "Künstler {{artistName}} von der Wunschliste entfernen",
                "body": "Sind Sie sicher, dass Sie den Künstler {{artistName}} von Ihrer Wunschliste entfernen möchten?"
            }
        },
        "message": {
            "subscriptionUpgrade": "Ihr aktueller Abonnementplan unterstützt diese Funktion nicht. Bitte <1>aktualisieren</1> Sie Ihren Abonnementplan, um diese Funktion zu nutzen.",
            "subscriptionExpired": "Ihr Abonnement ist abgelaufen. Bitte <1>setzen</1> Sie Ihr Abonnement fort, um diese Funktion zu nutzen.",
            "noAccess": "Sie haben keinen Zugriff auf dieses Modul, bitte kontaktieren Sie das Support-Team für weitere Informationen."
        }
    }
};

export default artistsWishlistDE;